// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"filterList_is-mob__OhX_8","is-desk":"filterList_is-desk__klfmc","list":"filterList_list__IBxIN","list__item":"filterList_list__item__4dRuG"};